export default {
  'settings.profile.myProfile': 'My Profile',
  'settings.profile.basicDetails': 'Basic Details',
  'settings.profile.security': 'Security',
  'settings.profile.description':
    'Set a new password to your aeroSUITE account.',
  'settings.profile.successChangePassword': 'Password updated',
  'settings.profile.loadProfileError':
    "Can't load user profile. Please try later.",
  'settings.profile.cantUpdateProfile':
    "Can't update profile now. Please try later.",
  'settings.profile.profileUpdated': 'Profile updated',
  'settings.profile.imageDimentionInfo':
    'Image should be .png or .jpeg type and dimension of 512px x 512px',
  'settings.profile.uploadImage': 'Upload Image',
  'settings.profile.dobInput': 'Date of Birth',
  'settings.profile.dojInput': 'Date of Join',
  'settings.profile.employeeInput': 'Employee Number',
  'settings.profile.jobTitleInput': 'Job Title',
  'settings.profile.languageCode': 'Preferred Language',
  'settings.profile.mobileInput': 'Primary Mobile',
  'settings.profile.secondMobileInput': 'Secondary Mobile',
  'settings.profile.maxPhoneLength':
    'Phone number should be less than 15 characters.',
  'settings.profile.workInput': 'Work Phone',
  'settings.profile.email': 'Email Address',
  'settings.profile.addressInput': 'Postal Address',
  'settings.profile.notSet': 'Not Set',
  'settings.profile.addressPlaceholder': 'Enter your address',
  'settings.profile.maxAddressLength':
    'Address should be less than 1000 characters. Please shorten'
};
